module.exports = __webpack_public_path__ + "static/media/violin.6cbe83c8.svg";